import React from 'react';
import { motion } from 'framer-motion';
import styles from './SectionAbout.module.scss';

const SectionAbout: React.FC = () => {
  return (
    <section className={`${styles.aboutSection} light-section`} id="home-about">
      <div className="container">
        <motion.div
          className={styles.headingWrapper}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className={styles.heading}>TECHNOLOGY WITH PURPOSE.</h2>
          <div className="gradient-line"></div>
        </motion.div>

        <div className={styles.grid}>
          <motion.div
            className={styles.leftCol}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h3 className={styles.statement}>
              WE BUILD DIGITAL PRODUCTS<br />
              THAT MOVE BUSINESSES FORWARD.
            </h3>
          </motion.div>
          
          <motion.div
            className={styles.rightCol}
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <p className={styles.description}>
              Arkatechs is a technology and digital solutions company focused on building modern digital products, experiences, and growth systems for businesses worldwide. From websites and mobile applications to UI/UX design, AI-powered solutions, digital marketing, SEO, hosting, and brand identity, we bring technology and creativity together under one roof.
            </p>
          </motion.div>
        </div>
      </div>
      
      {/* Decorative elements */}
      <div className="dot-grid" />
      <div className="concentric-circles" />
    </section>
  );
};

export default SectionAbout;
